import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as me from '../../me'

import { getActionsConfig } from './actions'
import * as cytoscape from './cytoscape'
import * as effects from './effects'
import { registerMarkdownExtension } from './markdown-extension'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * A {@link store.Feature} that manages org charts for Summit
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link cytoscape.Manager} */
  public readonly cytoscapeManager: cytoscape.Manager

  constructor() {
    super({
      actions: getActionsConfig(() => this.cytoscapeManager),
      initialState: State.INITIAL,
      name: 'SummitOrgChart',
      selectors: () => new Selectors(this),
    })

    const meFeature = ngCore.inject(me.Feature)
    this.registerEffects(
      effects.loadFromLocalStorage(meFeature),
      effects.loadOnEnteringOrgChartPage(meFeature),
      effects.saveToLocalStorage(meFeature),
      effects.saveOnDataChange(),
    )

    // NOTE: this has side effects
    this.cytoscapeManager = new cytoscape.Manager(this)

    registerMarkdownExtension(this)
  }
}
